import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { Check } from 'lucide-react'

export const muteDuration = {
  forever: 0,
  '6h': 6 * 60 * 60,
  '12h': 12 * 60 * 60,
  '24h': 24 * 60 * 60,
  '7 days': 7 * 24 * 60 * 60,
  '30 days': 30 * 24 * 60 * 60,
}

type TMuteOptions = {
  selected: keyof typeof muteDuration
  onSelect: (key: keyof typeof muteDuration) => void
}

const MuteOptions: FC<TMuteOptions> = ({ selected, onSelect }) =>
  Object.keys(muteDuration).map((key: string) => (
    <span
      key={key}
      data-testid={`mute-option-${key}`}
      className={cn(
        'p-xxs gap-xxxs flex cursor-pointer rounded-full border border-gray-400 bg-transparent text-sm',
        {
          'border-gray-100 bg-gray-100': selected === key,
        },
      )}
      onClick={() => onSelect(key as keyof typeof muteDuration)}
    >
      {selected === key && <Check size={16} />}
      {key === 'forever' ? 'Until I unmute' : `For ${key}`}
    </span>
  ))

export default MuteOptions
